import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import {
  type FullCancellationSheetVariant,
  getFullCancellationPaymentDueDate,
} from '@/scopes/account/booking-details/pages/selectors/fullCancellationSelectors'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './PartialCancellationSubmitResult.module.css'

interface FullCancellationSubmitResultProps {
  variant: FullCancellationSheetVariant
}

interface FullCancellationSubmitResultConfig {
  titleKey: string
  messageKey: string
}

const FULL_CANCELLATION_SUBMIT_SUCCESS_CONFIG: Record<
  FullCancellationSheetVariant,
  FullCancellationSubmitResultConfig
> = {
  'free': {
    titleKey: 'booking_details_cancel_booking_full_cancellation_submit_success_title',
    messageKey: 'booking_details_cancel_booking_full_cancellation_submit_success_message',
  },
  'with-cost': {
    titleKey: 'booking_details_cancel_booking_full_cancellation_with_cost_submit_success_title',
    messageKey: 'booking_details_cancel_booking_full_cancellation_with_cost_submit_success_message',
  },
}

export function FullCancellationSubmitResult({ variant }: FullCancellationSubmitResultProps) {
  const { formatMessage } = useIntl()
  const locale = useConfiguration('locale')
  const { cancelBookingDialogClosed } = useBookingDetailsActions()
  const successConfig = FULL_CANCELLATION_SUBMIT_SUCCESS_CONFIG[variant]
  const messageValues = variant === 'with-cost'
    ? { paymentDueDate: getFullCancellationPaymentDueDate(locale) }
    : undefined

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Icon glyph="CheckMarkInCircle" size={48} className={styles.iconSuccess} />
        <Typography variant="body-m-bold-snug" as="h2">
          {formatMessage({ id: successConfig.titleKey })}
        </Typography>
        <Typography variant="body-s-regular-snug" as="p">
          {formatMessage({ id: successConfig.messageKey }, messageValues)}
        </Typography>
        <Button className={styles.closeButton} onClick={cancelBookingDialogClosed}>
          {formatMessage({ id: 'booking_details_cancel_booking_full_cancellation_confirm_button_label' })}
        </Button>
      </div>
    </div>
  )
}
